import ResizableModal from '../../../../../ui/ResizableModal'
import { Button } from '../../../../../ui'
import { MAX_WAREHOUSES } from '../../constants/inventoryWarehouse'

const CreateWarehouseModal = ({ actions, data, open, state }) => (
  <ResizableModal
    open={open}
    onClose={actions.handleCloseCreateWarehouseModal}
    width={720}
    height={560}
    minWidth={620}
    minHeight={460}
    footer={
      <>
        <Button
          onClick={actions.handleCloseCreateWarehouseModal}
          className='rounded-full bg-primary text-sm uppercase text-white'
          title='CERRAR'
          disabled={actions.createWarehouseMutation.isPending}
        />
        <Button
          type='submit'
          form='inventory-create-warehouse-form'
          className='rounded-full bg-accent2 text-sm uppercase text-white'
          title={actions.createWarehouseMutation.isPending ? 'CREANDO...' : 'CREAR BODEGA'}
          disabled={actions.createWarehouseMutation.isPending || !data.hasWarehouseCapacity}
        />
      </>
    }
  >
    <div className='mx-auto w-full max-w-2xl'>
      <div className='mb-4 flex items-start justify-between gap-4'>
        <div>
          <p className='text-[11px] font-semibold uppercase tracking-[0.14em] text-accent2'>
            Alta individual
          </p>
          <h3 className='mt-1 text-2xl font-semibold text-slate-950'>Crear nueva bodega</h3>
          <p className='mt-1 text-sm text-slate-600'>
            Crea bodegas adicionales para operar inventario por ubicación. El código se asigna automáticamente.
          </p>
        </div>
      </div>

      <form
        id='inventory-create-warehouse-form'
        className='space-y-4 rounded-2xl bg-white p-4 shadow-sm'
        onSubmit={actions.handleWarehouseSubmit}
      >
        <div>
          <label className='mb-1 block text-xs font-semibold text-slate-700'>Código</label>
          <input
            type='text'
            value={data.nextWarehouseCode || `Límite ${MAX_WAREHOUSES} bodegas`}
            readOnly
            className='w-full rounded-lg border border-gray-300 bg-slate-50 px-3 py-2 text-sm text-slate-700'
          />
          <p className='mt-1 text-xs text-slate-500'>
            Se genera automáticamente en formato `BOD-01` a `BOD-10`.
          </p>
        </div>

        <div>
          <label className='mb-1 block text-xs font-semibold text-slate-700'>Nombre</label>
          <input
            type='text'
            value={state.warehouseForm.name}
            onChange={event => state.setWarehouseForm(prev => ({ ...prev, name: event.target.value }))}
            className='w-full rounded-lg border border-gray-300 px-3 py-2 text-sm'
            placeholder='Bodega principal'
          />
        </div>

        <div className='grid grid-cols-1 gap-3 sm:grid-cols-2'>
          <label className='flex items-start gap-2 rounded-lg border border-slate-200 p-3 text-sm text-slate-700'>
            <input
              type='checkbox'
              checked={state.warehouseForm.isDefault}
              onChange={event =>
                state.setWarehouseForm(prev => ({ ...prev, isDefault: event.target.checked }))
              }
              className='mt-0.5'
            />
            <span>
              <span className='block font-medium'>Bodega predeterminada</span>
              <span className='text-xs text-slate-500'>Se usará por defecto en movimientos y cargas.</span>
            </span>
          </label>

          <label className='flex items-start gap-2 rounded-lg border border-slate-200 p-3 text-sm text-slate-700'>
            <input
              type='checkbox'
              checked={state.warehouseForm.isActive}
              onChange={event =>
                state.setWarehouseForm(prev => ({ ...prev, isActive: event.target.checked }))
              }
              className='mt-0.5'
            />
            <span>
              <span className='block font-medium'>Activa</span>
              <span className='text-xs text-slate-500'>Permite usar esta bodega en el sistema.</span>
            </span>
          </label>
        </div>

        {!data.hasWarehouseCapacity ? (
          <div className='rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800'>
            Se alcanzó el límite de bodegas permitido por el módulo.
          </div>
        ) : null}
      </form>
    </div>
  </ResizableModal>
)

export default CreateWarehouseModal
